import { memo } from 'react'

const DorpDownArrowIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#637381"
      d="M10 12.917a.83.83 0 0 1-.533-.191l-5-4.167a.834.834 0 0 1 1.067-1.283L10 11.009l4.467-3.6a.833.833 0 0 1 1.175.125.833.833 0 0 1-.117 1.217l-5 4.025a.83.83 0 0 1-.525.141"
    ></path>
  </svg>
  )
}

export default memo(DorpDownArrowIcon);
